import axios from 'axios'

const HTTP_ERP = axios.create({
  baseURL: location.protocol + '//' + process.env.VUE_APP_BASE_URL_WS_ERP,
  headers: {
    'Content-Type': 'application/json'
  }
})
// Por si queremos hacer algo antes de ejecutar el request.
HTTP_ERP.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token')

    if (token) {
      config.headers['x-ddol-security-token'] = token
    }

    config.data.appOrigin = 'ECANALDENUNCIAS'
    config.data.privWeb = 'N'

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
HTTP_ERP.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default HTTP_ERP
